import handorgel from 'handorgel';

let accordions = document.querySelectorAll('.handorgel');

for (let i = 0; i < accordions.length; i++) {
    let accordion = accordions[i];

    let instance = new handorgel(accordion, {
        multiSelectable: false
    });

    // TEMP diagnostic: open all folds immediately so we can verify form
    // styles load correctly without the hidden-at-init variable.
    // Remove once the GF-in-accordion styling is confirmed working.
    if (new URLSearchParams(window.location.search).has('accordion_open')) {
        instance.folds.forEach(function (fold) { fold.open(false); });
    }

    // When a fold finishes opening, re-trigger GF's post-render event for
    // any forms inside it. GF initialises JS (conditional logic, datepicker,
    // etc.) at page load, but hidden containers return zero dimensions so
    // some initialisations silently fail until the element is visible.
    instance.on('fold:opened', function (fold) {
        const content = fold.content;
        if (!content || typeof window.jQuery === 'undefined') return;

        content.querySelectorAll('.gform_wrapper[data-form-id]').forEach(function (wrapper) {
            const formId = wrapper.getAttribute('data-form-id');
            if (formId) {
                window.jQuery(document).trigger('gform_post_render', [parseInt(formId, 10), 1]);
            }
        });
    });
}